import React from 'react';
import { RouteComponentProps } from 'react-router';
import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';
import { Spin } from '@beehive/components';
import _ from 'lodash';
import PropTypes from 'prop-types';
import * as actions from 'modules/actions/smProjectDetail';
import { projectMove, projectDelete } from 'modules/actions/smProjectMove';
import Show from '../Show';

interface ProjectDetailSingleProps
  extends RouteComponentProps<{ id?: string }> {
  prefixCls: string;
  account: any;
  menus: any;

  detailLoading: boolean;
  detail: any;
  loadDetail: Function;
  clearDetail: Function;
  projectMove: Function;
  projectDelete: Function;

  menuRequestMapping?: any;
  getBodyProgress?: any;
  getBottomTabElement?: any;
  baseInfoProps?: any;
  planInfoConfig?: any;
  settleInfoConfig?: any;
  readOnly?: boolean;
}

class Index extends React.Component<ProjectDetailSingleProps> {
  static defaultProps = {
    prefixCls: 'sm-project-detail',
  };

  static childContextTypes = {
    account: PropTypes.object,
    menuKey: PropTypes.any,
    detail: PropTypes.object,
    detailLoading: PropTypes.bool,

    loadDetail: PropTypes.func,
    projectMove: PropTypes.func,
    projectDelete: PropTypes.func,
  };

  componentDidMount(): void {
    this.loadDetail();
  }

  getMenuKey = () => {
    const { menus, location } = this.props;
    let menuKey = null;

    if (menus) {
      const keys = menus.map((item: any) => item.key);
      const nowLocation = location.pathname;
      menuKey = keys.find(
        (key: string) => !!~nowLocation.indexOf(_.camelCase(key)),
      );
    }

    return menuKey;
  }

  getChildContext = () => {
    const {
      account,
      detail,
      detailLoading,
      projectMove,
      projectDelete,
      menuRequestMapping,
    } = this.props;

    let menuKey = this.getMenuKey();
    if (menuRequestMapping) {
      menuKey = menuRequestMapping[menuKey] || menuKey;
    }

    return {
      account,
      menuKey,
      detail,
      detailLoading,
      loadDetail: this.loadDetail,
      projectMove,
      projectDelete,
    };
  }

  loadDetail = () => {
    const { match, loadDetail } = this.props;
    const { params = {} } = match || {};
    const { id = '' } = params || {};
    const menuKey = this.getMenuKey();
    loadDetail(id, {}, menuKey);
  }

  render(): React.ReactNode {
    const {
      match,
      prefixCls,
      detailLoading,
      getBodyProgress,
      getBottomTabElement,
      baseInfoProps,
      planInfoConfig,
      settleInfoConfig,
      readOnly = true,
    } = this.props;
    const classPrefix = `${prefixCls}-single`;
    const { params = {} } = match || {};
    const { id = '' } = params || {};

    return (
      <div className={classPrefix}>
        <Spin.Global spinning={detailLoading} />
        <Show
          prefixCls={prefixCls}
          projectId={id}
          getBodyProgress={getBodyProgress}
          getBottomTabElement={getBottomTabElement}
          baseInfoProps={baseInfoProps}
          planInfoConfig={planInfoConfig}
          settleInfoConfig={settleInfoConfig}
          readOnly={readOnly}
        />
      </div>
    );
  }
}

const mapStateToProps = (state: any, ownProps: any) => {
  const account = state.account;
  const smProjectDetail = ownProps.projectDetail || state.smProjectDetail;
  let menus = ownProps.menus;

  if (!menus) {
    const menu = _.find(_.get(account, 'menus') || [], (menu: any) => {
      return menu.key === 'smWorkbench';
    });
    menus = _.get(menu, 'children') || [];
  }

  return { account, menus, ...smProjectDetail };
};

const mapDispatchToProps = (
  dispatch: Dispatch<actions.ProjectDetailActions>,
  ownProps: any,
) => {
  return bindActionCreators(
    {
      loadDetail: ownProps.loadDetail || actions.loadDetail,
      clearDetail: ownProps.clearDetail || actions.clearDetail,
      toggleDrawerSiderShow:
        ownProps.toggleDrawerSiderShow || actions.toggleDrawerSiderShow,
      projectMove: ownProps.projectMove || projectMove,
      projectDelete: ownProps.projectDelete || projectDelete,
    },
    dispatch,
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Index);
